import { Unit } from '../price';
import { MgSupplierItemPackageDTO } from '../../dto/mgItem/MgSupplierItemPackageDTO';
import { MgPackageClassCode, MgPackageType, salesPackages } from './MgItemPackageValues';

interface ConstructorProps {
  gtinCode?: string;
  calculatedCount: number;
  deliverable: boolean;
  unit: Unit;
  grossWeight?: number;
  basePrice?: number;
  basePriceUnit?: boolean;
  recommendedSalesPrice?: number;
  priceComparisonUnit?: boolean;
  classCode: MgPackageClassCode;
  type: MgPackageType;
}

export class MgSupplierItemPackage {
  gtinCode?: string;
  calculatedCount: number;
  deliverable: boolean;
  unit: Unit;
  grossWeight?: number;
  basePrice?: number;
  basePriceUnit?: boolean;
  recommendedSalesPrice?: number;
  priceComparisonUnit?: boolean;
  classCode: MgPackageClassCode;
  type: MgPackageType;

  constructor({
    gtinCode,
    calculatedCount,
    deliverable,
    unit,
    grossWeight,
    basePrice,
    basePriceUnit,
    recommendedSalesPrice,
    priceComparisonUnit,
    classCode,
    type,
  }: ConstructorProps) {
    this.gtinCode = gtinCode;
    this.calculatedCount = calculatedCount;
    this.deliverable = deliverable;
    this.unit = unit;
    this.grossWeight = grossWeight;
    this.basePrice = basePrice;
    this.basePriceUnit = basePriceUnit;
    this.recommendedSalesPrice = recommendedSalesPrice;
    this.priceComparisonUnit = priceComparisonUnit;
    this.classCode = classCode;
    this.type = type;
  }

  static fromDto = ({
    gtinCode,
    calculatedCount,
    vilmaUnit,
    unit,
    grossWeight,
    basePriceUnit,
    priceComparisonUnit,
    type,
    deliverable,
    basePrice,
    recommendedSalesPrice,
    classCode,
  }: MgSupplierItemPackageDTO): MgSupplierItemPackage => {
    return new MgSupplierItemPackage({
      calculatedCount,
      unit: vilmaUnit ? Unit.fromDto(vilmaUnit) : Unit.fromDto(unit),
      grossWeight,
      priceComparisonUnit,
      type,
      deliverable,
      basePrice,
      basePriceUnit,
      recommendedSalesPrice,
      classCode,
      gtinCode,
    });
  };

  isSalesPackage = (): boolean => salesPackages.some((p) => p === this.type);
}
